import { render, staticRenderFns } from "./BusinessRequirementList.vue?vue&type=template&id=55b138b5"
import script from "./BusinessRequirementList.vue?vue&type=script&lang=js"
export * from "./BusinessRequirementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports